'use strict'

/**
 * Name: よく使うヘルパー
 */

/**
 * 文字列からHTMLタグを取り除く
 * @param {String} str -
 * @return {String} HTMLタグを除去した文字列
 */
export function removeHTMLTag(str = '') {
  return str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
}

/**
 * rand - ランダムに値を取得する
 * @param {Number} min - 1
 * @param {Number} max - 2
 * @return {Number} 1.5
 */
export function rand(min, max) {
  return Math.floor((Math.random() * (max - min + 1)) + min)
}

/**
 * 配列内からランダムに値を取得する
 *
 * @param {Array} array 配列
 * @return 配列内の値
 */
export function randArray(array = []) {
  const aryKeys = Object.keys(array)
  const index = aryKeys[Math.floor(Math.random() * aryKeys.length)]
  return array[index]
}

/**
 * isNumber - 引数が数値かどうか判定する http://qiita.com/hyakuson/items/5195f9a07cc105430152
 * @param {Number} min - 1
 * @param {Number} max - 2
 * @return {Number} 1.5
 */
export function isNumber(value) {
  return typeof value === 'number' && isFinite(value)
}

/**
 * typeOf - 型判定
 * http://qiita.com/sdn_tome/items/ef0b797156b324bb4ef3
 * http://qiita.com/south37/items/c8d20a069fcbfe4fce85
 * @param {String|Object|Array|Number} obj - 判定したものを指定
 * @return {String} - [object Object] | [object Array] ...
 */
export function typeOf(obj) {
  const toString = Object.prototype.toString
  return toString.call(obj).slice(8, -1).toLowerCase()
}

/**
 * 少数点を第n位を切り捨てる
 *
 * @param {Number} number
 * @param {Number} n - 第n位
 * @return {Number}
 */
export const MATH_POW = (number, n = 5) => {
  return Math.floor(number * Math.pow(10, n)) / Math.pow(10, n)
}
